import { Middleware } from 'redux';
import { navigateTo } from '@/utils/navigator'; 
import { CALL_HISTORY_METHOD } from '@/App/router/constants'; 

export const routerMiddleware = (history: any): Middleware => () => (next) => (action) => {
  if (action.type !== CALL_HISTORY_METHOD) {
    return next(action);
  }

  const { payload: { method, args } } = action;

  // Intercept 'push' and 'replace' to use React Router v6 hook via the navigator utility
  if (method === 'push') {
      navigateTo(args[0]);
  } else if (method === 'replace') {
      navigateTo(args[0], { replace: true });
  } else if (method === 'goBack') {
      navigateTo(-1 as any); 
  } else {
      console.warn('[RouterMiddleware] Unsupported method:', method);
  }

  return next(action);
};